export const USER_ROUTES = {
    RELEASE: 'release',
    RELEASE_NEW: 'new',
    RELEASE_DRAFT: 'draft/:id',
    INTAKE: 'intake'
};
